import React from 'react'
import imageOne from '../../resource/aboutus/mission/f1.png'
import bottomImage from '../../resource/aboutus/mission/f2.png'

const Mission = () => {
    return (
        <div className="mission-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>


            <div className="mission-page-section-one p-4">
                <h1 className='font-main  mt-4'>Our Mission</h1>
                <h3 className='mt-4 font-second'>Bhaddeka Vihari Buddhist Monastery</h3>


                <p className='font-p  mt-4'>Our mission through the Bhaddeka Vihari Monastery and Meditation Retreat Centre is to provide a peaceful and conducive environment for the practice of Dhamma Vinaya, fostering deep reflection on the truths of existence as taught by the Lord Buddha. We aim to nurture the community with Buddhist philosophy through dedicated practice, preserving ancient Buddhist culture, and safeguarding the Buddha’s teachings for future generations</p>
            </div>

            <div className="mission-page-section-two p-4">
                <h1 className='font-second mt-5 mb-4'>Our commitments include; </h1>


                <h2 className='mt-4'>1. Preserving Ancient Buddhist Teachings and Practices:</h2>
                <p className='mt-4'>We are committed to creating a supportive environment where Buddhist teachings can be studied, taught, and practiced extensively. This initiative will positively influence the lives of both the Monks (Sangha) and lay communities, ensuring the preservation of the Dhamma for present and future generations through knowledge and practice.</p>

                <h2 className='mt-4'>2. Protecting Traditional Buddhist Culture:</h2>
                <p className='mt-4'>We strive to foster and sustain traditional Buddhist culture, promoting the well-being of the community and encouraging a harmonious way of life based on Buddhist values.</p>

                <h2 className='mt-4'>3. Establishing a Conducive Monastery:</h2>
                <p className='mt-4'>We aim to establish a forest monastery that provides an ideal environment for the practice of Dhamma Vinaya (discipline), enabling deep reflection on the nature of existence as taught by the Buddha.</p>
                <p className="mt-4">The Sri Kalyani Yoghashrama Sansthawa in Sri Lanka was founded to secure the forest Sangha tradition, supporting the Sangha in solitary practice. Its founders include:</p>

                <ul className='mt-4'>
                    <li>Most Venerable Matara Gnanarama Maha Thero</li>
                    <li>Most Venerable Kdawadduwa Jinawansa Maha Thero</li>
                    <li>Most Venerable Nauyana Ariyadhamma Maha Thero</li>
                </ul>

                <p className="mt-4">The Bhaddeka Vihari Monastery and Meditation Retreat Centre in Victoria, Australia continues this sacred tradition under the umbrella of the Sri Kalyani Yoghashrama Sansthawa, Sri Lanka.</p>


                <h2 className="mt-4">4. Conducting Dhamma Teaching Programs and Meditation Retreats:</h2>
                <p className="mt-4">We are committed to offering a Centre that fosters an ideal environment for conducting Dhamma teaching programs and residential meditation retreats, welcoming individuals from all backgrounds and age groups for spiritual growth and development.</p>






                

               
            </div>

          

            <div className="bottom-box mt-5">
                <img src={bottomImage} alt="bottom-image" width={400} />
          
    </div>


        </div>
    )
}

export default Mission